import { CatalogItemKind, isSyntheticCatalogTrackMaid } from 'fym-shared/src/smartlinks/catalog';
import { CatalogItem } from '../../../redux/api/fymAPI.types';
import { CreationSource } from './types';

interface InitialCreationSourceInput {
  /** A catalog track that is out (a Catalog row that is out pressed "Create link"). */
  initialCatalogTrackMaid?: string;
  /** A catalog row (a row that is not out, or `?catalogItemUuid=` on the SmartLinks page). */
  initialCatalogItemUuid?: string;
  catalogItems: CatalogItem[];
}

/**
 * The song the sheet opens on, or undefined to open empty.
 *
 * A real track key opens the track. A row uuid opens the row: a row that is out with a real track
 * key opens its track (the same rule as `catalogCreationSource`), every other row opens as a row.
 * Undefined while the catalog has no row with the uuid (it can still load).
 */
export function initialCreationSource({
  initialCatalogTrackMaid,
  initialCatalogItemUuid,
  catalogItems,
}: InitialCreationSourceInput): CreationSource | undefined {
  // A synthetic key belongs to a row we hold everything for, so it is opened
  // as a row rather than read out of musicapi, which answers nothing for it.
  if (initialCatalogTrackMaid !== undefined && !isSyntheticCatalogTrackMaid(initialCatalogTrackMaid)) {
    return { kind: 'catalogTrack', trackMaid: initialCatalogTrackMaid };
  }
  if (initialCatalogItemUuid === undefined || initialCatalogItemUuid === '') {
    return undefined;
  }
  const item = catalogItems.find((candidate) => candidate.uuid === initialCatalogItemUuid);
  if (item === undefined) {
    return undefined;
  }
  if (
    item.kind === CatalogItemKind.claimed &&
    item.catalogTrackMaid !== null &&
    !isSyntheticCatalogTrackMaid(item.catalogTrackMaid)
  ) {
    return { kind: 'catalogTrack', trackMaid: item.catalogTrackMaid, title: item.title };
  }
  return { kind: 'catalogRow', item };
}
